import { AzmoonMaharatDetail_Files_Interface } from "./AzmoonMaharatDetail_Files_Interface"

export interface AzmoonMaharatDetail_Interface {
    id:number,
    title:string,
    startDate:string,
    endDate:string,
    file:Array<AzmoonMaharatDetail_Files_Interface>,
    file1:Array<AzmoonMaharatDetail_Files_Interface>,
    del:boolean,
    canSubmit:boolean,
  }
  
  export function Empty_AzmoonMaharatDetail_Interface():AzmoonMaharatDetail_Interface{
    return{
      id:0,
      title:'',
      startDate:'',
      endDate:'',
      file:[],
      file1:[],
      canSubmit:false,
      del:false,
    }
  }